import PropTypes from 'prop-types';
import React from 'react';
import StateNavigationLinkColumn from './StateNavigationLinkColumn.js';
import StateSubDirectory from './StateSubDirectory.js';

const minStatesPerRow = 5;
const maxStateNavigationRows = 4;

export default class Directory extends React.Component {
    getStateColumns(array) {
        const numPerRow = Math.max(minStatesPerRow, Math.ceil(array.length / maxStateNavigationRows));
        const numToShow = array.length;
        if (numToShow <= minStatesPerRow) {
            return [array];
        }

        const resultRows = [];
        let rowIndexStart = 0;
        let rowIndexEnd = numPerRow;
        while (rowIndexEnd <= numToShow) {
            resultRows.push(array.slice(rowIndexStart, rowIndexEnd));
            rowIndexStart += numPerRow;
            rowIndexEnd += numPerRow;
        }
        if (rowIndexEnd > numToShow) {
            resultRows.push(array.slice(rowIndexStart));
        }
        return resultRows;
    }

    getStateNavigationLinks() {
        if (this.props.isMobile) {
            return null;
        }

        const stateNavigationLinkRowsData = this.getStateColumns(this.props.stateNames);
        const stateNavigationLinkRows = stateNavigationLinkRowsData.map(function (navigationLinkRowData, index) {
            return (
                <StateNavigationLinkColumn key={'statenav-' + index} stateNames={navigationLinkRowData}/>
            );
        });
        return (
            <div className='fluid-container'>
                <hr/>
                {stateNavigationLinkRows}
            </div>
        );
    }

    render() {
        const renderedStateNavigationLinks = this.getStateNavigationLinks();
        const stateSubDirectories = this.props.stateNames.map((stateDisplayName) =>
            <StateSubDirectory
                districtData={this.props.districtData[stateDisplayName]}
                stateDisplayName={stateDisplayName}
                isMobile={this.props.isMobile}
                key={stateDisplayName}
            />);

        return (
            <div className='container district-partner-directory'>
                <div className='directory-header'>
                    <h1>District Partners</h1>
                    <p className='subheader'>Hundreds of districts partner with DonorsChoose. <a href={baseURL + 'districtpartners'}>Become a district partner</a>.</p>
                </div>
                {renderedStateNavigationLinks}
                {stateSubDirectories}
            </div>
        );
    }
}

Directory.propTypes = {
    districtData: PropTypes.object.isRequired,
    stateNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    isMobile: PropTypes.bool.isRequired,
};
